import {isFeatureEnabled} from '@github-ui/feature-flags'

/**
 * Whether the chat session opts into the cloud session store, which backs the
 * `session_store_sql` tool the `/chronicle` commands query.
 *
 * Reading a feature flag touches client env, which throws if it isn't ready yet.
 * Treat "env not ready" as flag-off so an unseeded env can't break session setup.
 */
export function isCloudSessionStoreEnabled(): boolean {
  try {
    return isFeatureEnabled('copilot_chat_cloud_session_store')
  } catch {
    return false
  }
}
